export default {
    en: {
        titrePaiementSansAssurance: 'Payment',
        titrePaiementAvecRedonductionAssurance: 'Payment with insurance',
        titrePaiementAssuranceP1P2: 'Total with insurance for the tied loan',
        titrePaiementAssuranceP3: 'Total with insurance',
        titreInfoBulleLibelle:
            'There may be a slight variation between the payment amount listed here and the one on your contract, due to certain circumstances.',
        titreInfoBulleHorsEcran: 'the payment',
        sousTitrePaiement:
            'Amount based on your mortgage balance on {{date, MMMM\xa0D}}, {{date, YYYY}}',
        sousTitrePaiementSI: 'As of {{date, MMMM\xa0D}}, {{date, YYYY}}',
        sousTitrePaiementAjoutAssurance: 'Payment with insurance',
        notePaiementAssurance_1: '(Payment ',
        notePaiementAssurance_2: '\xa0+\xa0additional amount for insurance ',
        notePaiementAssurance_3: ')',
        notePaiementAssuranceProtege_1:
            '(Payment calculated based on maximum rate ',
        notePaiementAssuranceProtege_2:
            '\xa0+\xa0additional amount for insurance ',
        notePaiementAssuranceProtege_3: ')',
        notePaiementAssuranceInfoBulleLibelleP1P2:
            'As explained in the “Cost of insurance” section of the Loan Insurance – Versatile Line of Credit Booklet, the additional amount for insurance is not the only factor in your total insurance cost.',
        notePaiementAssuranceInfoBulleLibelleP3:
            'As explained in the “Cost of insurance” section of the Loan Insurance Booklet, the additional amount for insurance is not the only factor in your total insurance cost.',
        notePaiementAssuranceInfoBulleHorsEcran:
            'the additional amount for insurance',
        sousTitreTauxAjoutAssuranceOffreFixe: 'Rate with insurance',
        sousTitreTauxAjoutAssuranceOffreAutre: 'Current rate with insurance',
        labelInfoBullesousTitreTauxAjoutAssuranceOffreFixe:
            'If you chose to make payments weekly or every 2\xa0weeks, you might notice that your total rate is less than the sum of the loan rate and insurance rate. This will always be to your benefit.',
        labelInfoBullesousTitreTauxAjoutAssuranceOffreAutre_1:
            'If you chose to make payments weekly or every 2\xa0weeks, you might notice that your total rate is less than the sum of the loan rate and insurance rate. This will always be to your benefit. The insurance rate will stay the same for ',
        labelInfoBullesousTitreTauxAjoutAssuranceOffreAutre_2: '.',
        labelHorsEcransousTitreTauxAjoutAssuranceOffre: 'the insurance rate',
        noteTauxAjoutAssuranceOffre_1: '(Including insurance rate of ',
        noteTauxAjoutAssuranceOffre_2: ')',
        note5dans1_1: ' (year\xa01)',
        note5dans1_2: '',
        note5dans1_3: '',
        noteVariableProtege: ' (calculated based on the maximum rate)',
        // Frequences
        HEBDOMADAIRE: ' weekly',
        AUX_DEUX_SEMAINES: ' every 2 weeks',
        MENSUELLE: ' monthly',
        HEBDOMADAIRE_ACCELEREE: ' weekly',
        AUX_DEUX_SEMAINES_ACCELEREE: ' every 2 weeks'
    },
    fr: {
        titrePaiementSansAssurance: 'Paiement',
        titrePaiementAvecRedonductionAssurance: 'Paiement avec assurance',
        titrePaiementAssuranceP1P2: 'Total avec assurance pour le prêt lié',
        titrePaiementAssuranceP3: 'Total avec assurance',
        titreInfoBulleLibelle:
            'Il pourrait y avoir une légère variation entre le montant du paiement affiché et celui de votre contrat à signer. Certaines circonstances expliquent cette différence.',
        titreInfoBulleHorsEcran: 'le paiement',
        sousTitrePaiement:
            'Montant basé sur le solde de votre prêt au {{date, D}}{{suffixe}}\xa0{{date, MMMM\xa0YYYY}}',
        sousTitrePaiementSI:
            'À partir du {{date, D}}{{suffixe}}\xa0{{date, MMMM\xa0YYYY}}',
        sousTitrePaiementAjoutAssurance: 'Paiement avec assurance',
        notePaiementAssurance_1: '(Paiement ',
        notePaiementAssurance_2: '\xa0+\xa0supplément pour assurance ',
        notePaiementAssurance_3: ')',
        notePaiementAssuranceProtege_1:
            '(Paiement calculé en fonction du taux maximum ',
        notePaiementAssuranceProtege_2: '\xa0+\xa0supplément pour assurance ',
        notePaiementAssuranceProtege_3: ')',
        notePaiementAssuranceInfoBulleLibelleP1P2:
            'Comme expliqué à la section «\xa0Coût de l’assurance\xa0» de la Brochure de l’Assurance prêt\xa0–\xa0marge Atout, le montant supplémentaire pour assurance n’est pas le seul élément du coût total de votre assurance.',
        notePaiementAssuranceInfoBulleLibelleP3:
            'Comme expliqué à la section «\xa0Coût de l’assurance\xa0» de la Brochure de l’Assurance prêt, le montant supplémentaire pour assurance n’est pas le seul élément du coût total de votre assurance.',
        notePaiementAssuranceInfoBulleHorsEcran:
            'le montant supplémentaire pour assurance',
        sousTitreTauxAjoutAssuranceOffreFixe: 'Taux d’intérêt applicable',
        sousTitreTauxAjoutAssuranceOffreAutre:
            'Taux d’intérêt applicable actuel',
        labelInfoBullesousTitreTauxAjoutAssuranceOffreFixe:
            "Si vous avez choisi de rembourser votre prêt chaque semaine ou aux 2\xa0semaines, le taux applicable est moins élevé que la somme du taux du prêt et du taux de l'assurance. Ceci est toujours à votre avantage.",
        labelInfoBullesousTitreTauxAjoutAssuranceOffreAutre_1:
            "Si vous avez choisi de rembourser votre prêt chaque semaine ou aux 2\xa0semaines, le taux applicable est moins élevé que la somme du taux du prêt et du taux de l'assurance. Ceci est toujours à votre avantage. Le taux pour l’assurance reste fixe durant ",
        labelInfoBullesousTitreTauxAjoutAssuranceOffreAutre_2: '.',
        labelHorsEcransousTitreTauxAjoutAssuranceOffre:
            'le taux pour l’assurance',
        noteTauxAjoutAssuranceOffre_1: '(Incluant le taux pour l’assurance de ',
        noteTauxAjoutAssuranceOffre_2: ')',
        note5dans1_1: ' (1',
        note5dans1_2: 're',
        note5dans1_3: '\xa0année)',
        noteVariableProtege: ' (calculé en fonction du taux maximum)',
        // Frequences
        HEBDOMADAIRE: ' par semaine',
        AUX_DEUX_SEMAINES: ' aux 2 semaines',
        MENSUELLE: ' par mois',
        HEBDOMADAIRE_ACCELEREE: ' par semaine',
        AUX_DEUX_SEMAINES_ACCELEREE: ' aux 2 semaines'
    }
};
